import { INavLinkGroup } from "office-ui-fabric-react";
import { NavigationPath } from "../../../config/routing/NavigationPath";

export const navLinkGroups = (t: (key: string) => string): INavLinkGroup[] => [
    {
        name: t("nav.clientsGroup"),
        links: [
            { key: `${NavigationPath.UNVERIFIED_CLIENTS}`, name: t("nav.unverifiedClients"), url: "" },
            { key: `${NavigationPath.ACTIVE_CLIENTS}`, name: t("nav.activeClients"), url: "" },
            { key: `${NavigationPath.INACTIVE_CLIENTS}`, name: t("nav.inactiveClients"), url: "" },
            { key: `${NavigationPath.RECEPTION_PLACES}`, name: t("nav.receptionPlaces"), url: "" },
        ],
    },
    {
        name: t("nav.ordersGroup"),
        links: [
            { key: `${NavigationPath.NEW_ORDERS}`, name: t("nav.newOrders"), url: "" },
            { key: `${NavigationPath.ACCEPTED_ORDERS}`, name: t("nav.acceptedOrders"), url: "" },
            { key: `${NavigationPath.IN_PROGRESS_ORDERS}`, name: t("nav.inProgressOrders"), url: "" },
            { key: `${NavigationPath.COMPLETED_ORDERS}`, name: t("nav.completedOrders"), url: "" },
            { key: `${NavigationPath.INVOICED_ORDERS}`, name: t("nav.invoicedOrders"), url: "" },
            { key: `${NavigationPath.CANCELED_ORDERS}`, name: t("nav.canceledOrders"), url: "" },
            { key: `${NavigationPath.ALL_ORDERS}`, name: t("nav.allOrders"), url: "" },
        ],
    },
    {
        name: t("nav.validatorsGroup"),
        links: [
            { key: `${NavigationPath.CONTAINERS_VALIDATORS}`, name: t("nav.containersValidators"), url: "" },
            { key: `${NavigationPath.RECEPTION_PLACES_VALIDATORS}`, name: t("nav.receptionPlacesValidators"), url: "" },
            { key: `${NavigationPath.ORDERS_VALIDATORS}`, name: t("nav.ordersValidators"), url: "" },
        ],
    },
    {
        name: t("nav.pricingGroup"),
        links: [
            { key: `${NavigationPath.GENERAL_PRICE_LIST}`, name: t("nav.generalPricelist"), url: "" },
            { key: `${NavigationPath.DETAILED_PRICE_LIST}`, name: t("nav.detailedPricelist"), url: "" },
        ],
    },
    {
        name: t("nav.storeGroup"),
        collapseByDefault: true,
        links: [
            { key: `${NavigationPath.STORE_LIST}`, name: t("nav.storeList"), url: "" },
            { key: `${NavigationPath.INTERALSTORE_LIST}`, name: t("nav.internalStoreList"), url: "" },
            { key: `${NavigationPath.STORE_DOCS_LIST}`, name: t("nav.storeDocsList"), url: "" },
            { key: `${NavigationPath.CONTAINERS_LIST}`, name: t("nav.containersList"), url: "" },
            { key: `${NavigationPath.STORE_MAP}`, name: t("nav.storeMap"), url: "" },
        ],
    },
    {
        name: t("nav.reportsGroup"),
        collapseByDefault: true,
        links: [
            { key: `${NavigationPath.REPORT_LIST}`, name: t("nav.reportList"), url: "" },
        ],
    },
    {
        name: t("nav.settingsGroup"),
        collapseByDefault: true,
        links: [
            { key: `${NavigationPath.ORDER_TYPES}`, name: t("nav.orderTypes"), url: "" },
            { key: `${NavigationPath.VEHICLES}`, name: t("nav.vehicles"), url: "" },
            { key: `${NavigationPath.DRIVERS}`, name: t("nav.drivers"), url: "" },
            { key: `${NavigationPath.OPERATORS}`, name: t("nav.operators"), url: "" },
            { key: `${NavigationPath.CANCELLATION_REASONS}`, name: t("nav.cancellationReasons"), url: "" },
            { key: `${NavigationPath.VALIDATOR_TYPES}`, name: t("nav.validatorTypes"), url: "" },
            { key: `${NavigationPath.NOT_CONFIRMED_USERS}`, name: t("nav.notConfirmedUsers"), url: "" },
            { key: `${NavigationPath.ADMINS}`, name: t("nav.admins"), url: "" },
        ],
    },
];